<template>
  <div class="fail-page">
    <div class="card-wrap">
      <header class="card-header">
        <div class="icon fail">✕</div>
        <div>
          <h1 class="title">결제 실패</h1>
          <p class="subtitle">결제 처리 중 오류가 발생했습니다.</p>
        </div>
      </header>

      <section v-if="loading" class="loading">⏳ 실패 정보를 불러오는 중...</section>
      <section v-else-if="error" class="error">{{ error }}</section>

      <section v-else class="card-body">
        <div class="notice">
          <p class="msg">결제에 실패하였습니다. 아래 응답 파라미터를 확인해주세요.</p>
        </div>

        <div v-if="hasData" class="grid">
          <div v-for="(value, key) in postData" :key="key" class="row">
            <div class="label">{{ key }}</div>
            <div class="value">
              <span class="mono">{{ displayValue(value) }}</span>
            </div>
          </div>
        </div>

        <div v-else class="empty">수신된 실패 데이터가 없습니다.</div>

        <div class="actions">
          <router-link to="/" class="btn btn-outline">홈으로</router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SmartroPayFail",
  data() {
    return {
      postData: {},
      loading: true,
      error: null
    };
  },
  computed: {
    hasData() {
      return this.postData && Object.keys(this.postData).length > 0;
    }
  },
  mounted() {
    const SERVER_URL = process.env.VUE_APP_API_BASE || "";
    const tid = this.$route.query.tid || this.$route.query.Tid || null;
    if (tid) {
      axios.get(`${SERVER_URL}/api/getPayFailByTid`, { params: { tid } })
        .then(res => {
          this.postData = res.data || {};
        })
        .catch(err => {
          console.error("getPayFailByTid error:", err);
          if (err.response && err.response.status === 404) {
            this.postData = {};
          } else {
            this.error = "실패 데이터를 불러오지 못했습니다.";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      // fallback: attempt to fetch by tid if provided in query (robust to empty tid)
      const fallbackTid = this.$route.query.tid || this.$route.query.Tid || '';
      axios.get(`${SERVER_URL}/api/getPayFailByTid`, { params: { tid: fallbackTid } })
        .then(res => {
          this.postData = res.data || {};
        })
        .catch(err => {
          console.error("getPayFailByTid fallback error:", err);
          if (err.response && (err.response.status === 404 || err.response.status === 400)) {
            this.postData = {};
          } else {
            this.error = "실패 데이터를 불러오지 못했습니다.";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    displayValue(v) {
      if (v === null || typeof v === "undefined" || v === "") return "-";
      if (typeof v === "object") return JSON.stringify(v);
      return String(v);
    }
  }
};
</script>

<style scoped>
.fail-page {
  display:flex;
  justify-content:center;
  padding:40px 16px;
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;
}
.card-wrap {
  width:100%;
  max-width:640px;
  background:#fff;
  border-radius:14px;
  box-shadow:0 10px 30px rgba(20,40,80,0.06);
  overflow:hidden;
  border:1px solid #fff1f2;
}
.card-header {
  display:flex;
  gap:16px;
  align-items:center;
  padding:22px 24px;
  background: linear-gradient(90deg,#fff6f7,#ffffff);
}
.icon {
  width:64px;
  height:64px;
  border-radius:50%;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:32px;
  font-weight:700;
  box-shadow:0 4px 12px rgba(10,100,80,0.04);
}
.icon.fail {
  background:#fff0f0;
  color:#d32f2f;
  box-shadow:0 6px 18px rgba(211,47,47,0.06);
}
.title {
  margin:0;
  font-size:20px;
  color:#c62828;
  font-weight:700;
}
.subtitle {
  margin:4px 0 0;
  color:#6b7280;
  font-size:13px;
}
.loading, .error, .empty {
  padding:28px;
  text-align:center;
  color:#6b7280;
}
.card-body {
  padding:20px 24px 28px;
}
.notice .msg {
  background:#fff6f7;
  border:1px solid #ffe8e8;
  padding:12px 14px;
  border-radius:8px;
  color:#b91c1c;
  font-weight:600;
  margin-bottom:12px;
}
/* 세로 스크롤만 허용, 가로 스크롤 숨김하여 깔끔하게 유지 */
.grid { 
  display:grid; 
  gap:10px; 
  max-height:360px; 
  overflow-y:auto; 
  overflow-x:hidden; 
  padding-right:6px; 
}
/* 각 행이 좁아져도 줄바꿈으로 내용이 깨지지 않도록 설정 */
.row { 
  display:flex; 
  justify-content:space-between; 
  align-items:center; 
  padding:8px 0; 
  border-bottom:1px dashed #f7ebeb; 
  gap:8px;
  word-break:break-word;
  flex-wrap:wrap;
}
.row:last-child { border-bottom:none; }
.label { color:#6b7280; font-size:13px; width:40%; min-width:120px; }
.value { color:#1f2d3d; font-weight:600; width:96%; text-align:right; }

/* displayValue(출력 텍스트)를 오른쪽 정렬 */
.mono { 
  font-family:monospace; 
  background:transparent; 
  padding:0; 
  border-radius:0; 
  display:block;       /* 전체 너비 사용 */
  width:100%;          /* 부모 영역에 맞춰 정렬 */
  text-align:right;    /* 오른쪽 정렬 적용 */
  color:#1f2d3d;
}

.actions { display:flex; gap:10px; margin-top:18px; justify-content:flex-end; }
.btn { padding:8px 14px; border-radius:8px; cursor:pointer; text-decoration:none; }
.btn-outline { border:1px solid #ffd6d6; color:#b91c1c; background:#fff; }

@media(max-width:520px){
  .card-wrap{padding:0;}
  .card-body{padding:16px;}
  .actions{flex-direction:column; align-items:stretch;}
  .label{width:45%}
  .value{width:55%}
}
</style>